import { useCallback } from "react";

import { useAccommodationHotelPolicyFormModelContext } from "../../../../../../context";

export const useIsCalendarStartFromAvailableMonth = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { isCalendarStartFromAvailableMonth } = viewModel;

	const isEdited = isCalendarStartFromAvailableMonth.isEdited;
	const hasError = Boolean(isCalendarStartFromAvailableMonth.error);

	const onSetIsCalendarStartFromAvailableMonth = useCallback(
		(input: boolean) => {
			onSetViewModel([
				{
					key: "isCalendarStartFromAvailableMonth",
					value: {
						...isCalendarStartFromAvailableMonth,
						value: input,
					},
				},
			]);
		},
		[isCalendarStartFromAvailableMonth, onSetViewModel],
	);

	return {
		isEdited,
		hasError,

		isCalendarStartFromAvailableMonth,
		onSetIsCalendarStartFromAvailableMonth,
	};
};
